import history from "@scandipwa/scandipwa/src/util/History";
import { generateQuery, getQueryParam, removeQueryParamWithoutHistory } from "@scandipwa/scandipwa/src/util/Url";
import FilterLabel from "Component/FilterLabel";
import RangeSlider from "Component/RangeSlider/RangeSlider.component";
import React, { PureComponent } from "react";

export class DiamondCarat extends PureComponent {
    static propTypes = {
        renderGetDiamond: this.propTypes
    }

    constructor(props) {
        super(props)
        this.state = {
            diamondcaratminvalue: 0.25,
            diamondcaratmaxvalue: 12,
            caratFilterminvalue: 0.25,
            caratFiltermaxvalue: 12,
            changevalue: false
        }
    }

    componentDidMount() {
        const location = window?.location;

        const diamondcaratfilter = getQueryParam("carat", location || '');

        if (diamondcaratfilter) {
            const diamondcaratfiltervalue = diamondcaratfilter.split("_");

            this.setState({
                diamondcaratminvalue: diamondcaratfiltervalue[0],
                diamondcaratmaxvalue: diamondcaratfiltervalue[1],
                caratFilterminvalue: diamondcaratfiltervalue[0],
                caratFiltermaxvalue: diamondcaratfiltervalue[1]
            });
        }
    }

    cahngediamondcaratminvalue = (e) => {
        console.log(e.target.value);
        this.setState({
            diamondcaratminvalue: e.target.value,
            changevalue: true
        });
    }

    cahngediamondcaratmaxvalue = (e) => {
        this.setState({
            diamondcaratmaxvalue: e.target.value,
            changevalue: true
        });
    }

    cahngeCaratminValue = (e) => {
        const { diamondcaratminvalue, diamondcaratmaxvalue } = this.state;
        let query = "";
        const { renderGetDiamond } = this.props;

        if (e.code === "Enter" || e.keyCode === 13) {
            if (diamondcaratminvalue > 12) {
                this.setState({
                    diamondcaratminvalue: 12,
                    caratFilterminvalue: 12
                });
                query = `12_${diamondcaratmaxvalue}`;
            } else if (diamondcaratminvalue < 0.25) {
                this.setState({
                    diamondcaratminvalue: 0.25,
                    caratFilterminvalue: 0.25
                })
                query = `0.25_${diamondcaratmaxvalue}`;
            } else if (diamondcaratminvalue > diamondcaratmaxvalue) {
                this.setState({
                    diamondcaratminvalue: diamondcaratmaxvalue,
                    caratFilterminvalue: diamondcaratmaxvalue
                });
                query = `${diamondcaratmaxvalue}_${diamondcaratmaxvalue}`;
            } else {
                this.setState({
                    diamondcaratminvalue: diamondcaratminvalue,
                    caratFilterminvalue: diamondcaratminvalue
                });
                query = `${diamondcaratminvalue}_${diamondcaratmaxvalue}`;
            }

            this.setState({
                changevalue: false
            });

            const pagefilter = getQueryParam("pageno", location || '');
            if (pagefilter) {
                removeQueryParamWithoutHistory('pageno', history, window.location);
            }

            history.push(generateQuery({ carat: query }, window.location, history));
            renderGetDiamond();
        }
    }

    cahngeCaratmaxValue = (e) => {
        const { diamondcaratminvalue, diamondcaratmaxvalue } = this.state;
        let query = "";
        const { renderGetDiamond } = this.props;

        if (e.code === "Enter" || e.keyCode === 13) {
            if (diamondcaratmaxvalue > 12) {
                this.setState({
                    diamondcaratmaxvalue: 12,
                    caratFiltermaxvalue: 12,
                });
                query = `${diamondcaratminvalue}_12`;
            } else if (diamondcaratmaxvalue < 0.25) {
                this.setState({
                    caratFiltermaxvalue: 0.25,
                    diamondcaratmaxvalue: 0.25
                })
                query = `${diamondcaratminvalue}_0.25`;
            } else if (diamondcaratminvalue > diamondcaratmaxvalue) {
                this.setState({
                    caratFiltermaxvalue: diamondcaratminvalue,
                    diamondcaratmaxvalue: diamondcaratminvalue
                });
                query = `${diamondcaratminvalue}_${diamondcaratminvalue}`;
            } else {
                this.setState({
                    caratFiltermaxvalue: diamondcaratmaxvalue,
                    diamondcaratmaxvalue: diamondcaratmaxvalue
                });
                query = `${diamondcaratminvalue}_${diamondcaratmaxvalue}`;
            }

            this.setState({
                changevalue: false
            });

            const pagefilter = getQueryParam("pageno", location || '');
            if (pagefilter) {
                removeQueryParamWithoutHistory('pageno', history, window.location);
            }

            history.push(generateQuery({ carat: query }, window.location, history));
            renderGetDiamond();
        }
    }

    onCaratInput(e) {
        if (this.state.changevalue === false) {
            this.setState({
                diamondcaratminvalue: e.minValue,
                diamondcaratmaxvalue: e.maxValue,
                caratFiltermaxvalue: e.maxValue,
                caratFilterminvalue: e.minValue
            })
        }
    }

    onCaratChange(e) {
        const { renderGetDiamond } = this.props;
        if (this.state.changevalue === false) {
            this.setState({
                diamondcaratminvalue: e.minValue,
                diamondcaratmaxvalue: e.maxValue,
                caratFiltermaxvalue: e.maxValue,
                caratFilterminvalue: e.minValue
            })
        }

        const pagefilter = getQueryParam("pageno", location || '');
        if (pagefilter) {
            removeQueryParamWithoutHistory('pageno', history, window.location);
        }

        history.push(generateQuery({ carat: `${e.minValue}_${e.maxValue}` }, window.location, history));
        renderGetDiamond();
    }

    renderDiamondCaratWeight() {
        return (
            <>
                <RangeSlider
                    label={false}
                    min={0.25}
                    max={12}
                    step={0.01}
                    minValue={this.state.caratFilterminvalue}
                    maxValue={this.state.caratFiltermaxvalue}
                    className={"caratrangeslider"}
                    oninput={(e) => this.onCaratInput(e)}
                    onChange={(e) => this.onCaratChange(e)}
                />
                <div className='carat-input-value'>
                    <input
                        className='caratvalue'
                        type='text'
                        value={this.state.diamondcaratminvalue}
                        onChange={this.cahngediamondcaratminvalue}
                        onKeyDown={this.cahngeCaratminValue}
                        name='minvalue'
                    />
                    <input
                        className='caratvalue'
                        type='text'
                        value={this.state.diamondcaratmaxvalue}
                        onChange={this.cahngediamondcaratmaxvalue}
                        onKeyDown={this.cahngeCaratmaxValue}
                        name='maxvalue'
                    />
                </div>
            </>
        )
    }

    render() {
        return (
            <FilterLabel label={" Total Carat Weight"}>
                {this.renderDiamondCaratWeight()}
            </FilterLabel>
        )
    }
}

export default DiamondCarat;